// ============================================
// WIZARD STEP-NAVIGATION KOMPONENTE
// Tabs oben mit Progress-Tracking
// ============================================

import React from 'react';
import './WizardSteps.css';

const WizardSteps = ({ currentStep, completedSteps, onStepClick }) => {
const steps = [
  { id: 1, name: 'Job-Details', icon: '📄', shortName: 'Job' },
  { id: 2, name: 'Bilder', icon: '🖼️', shortName: 'Bilder' },
  { id: 3, name: 'Branding', icon: '🎨', shortName: 'Brand' },
  { id: 4, name: 'Templates', icon: '✨', shortName: 'Templates' },
  { id: 5, name: 'Bewerbungsfragen', icon: '❓', shortName: 'Fragen' },
  { id: 6, name: 'Export', icon: '📦', shortName: 'Export' },
  { id: 7, name: 'Meta Ads', icon: '📱', shortName: 'Meta' }
];

  const getStepStatus = (stepId) => {
    if (completedSteps.includes(stepId)) return 'completed';
    if (stepId === currentStep) return 'active';
    if (stepId < currentStep) return 'clickable';
    return 'locked';
  };

  const getStepIcon = (step) => {
    const status = getStepStatus(step.id);
    if (status === 'completed') return '✓';
    if (status === 'active') return '●';
    return '○';
  };

  const handleStepClick = (stepId) => {
    const status = getStepStatus(stepId);
    // Nur zu abgeschlossenen oder aktuellen Schritten springen
    if (status === 'completed' || status === 'active' || status === 'clickable') {
      onStepClick(stepId);
    }
  };

  const progressPercentage = ((completedSteps.length) / steps.length) * 100;

  return (
    <div className="wizard-container">
      <div className="wizard-header">
        <h1>🎯 Job Ad Generator</h1>
        <p>Erstelle professionelle Meta Ads in 7 einfachen Schritten</p>
      </div>

      <div className="wizard-steps">
        {steps.map((step, index) => {
          const status = getStepStatus(step.id);
          const isLast = index === steps.length - 1;

          return (
            <React.Fragment key={step.id}>
              <div 
                className={`wizard-step ${status}`}
                onClick={() => handleStepClick(step.id)}
              >
                <div className="step-number">
                  <span className="step-icon">{step.icon}</span>
                  <span className="step-status">{getStepIcon(step)}</span>
                </div>
                <div className="step-label">
                  <span className="step-name">{step.shortName}</span>
                </div>
              </div>
              
              {!isLast && (
                <div className={`step-connector ${status === 'completed' ? 'completed' : ''}`}>
                  →
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <div className="progress-bar-container">
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
        <span className="progress-text">
          {completedSteps.length} von {steps.length} Schritten abgeschlossen
        </span>
      </div>
    </div>
  );
};

export default WizardSteps;
